import { MailFolderTableQuery, TableQuery, TableQueryType } from 'owa-mail-list-store';

/**
 * Evaluates whether the row removal instant update should be performed for the given table
 * @param tableQuery tableQuery for the table where the triage operation is being performed
 * @param isRowMovingToDeletedItemsFolder flag indicating whether the row is moving to the deleted items folder due to the triage operation
 * @returns a flag indicating whether the row removal instant update should be performed for the given table
 */
export default function shouldPerformRowRemovalInstantUpdate(
    tableQuery: TableQuery,
    isRowMovingToDeletedItemsFolder: boolean
): boolean {
    const scenarioType =
        tableQuery.type == TableQueryType.Folder
            ? (tableQuery as MailFolderTableQuery).scenarioType
            : '';

    switch (scenarioType) {
        case 'persona':
        case 'privatedistributionlist':
            // Do not perform row removal instant update if this is persona scenario
            return false;

        case 'category':
            // Do not perform row removal instant update if this is category scenario except
            // for when the destination folder is deletedItems folder
            return isRowMovingToDeletedItemsFolder;

        default:
            // for other cases always perform row removal instant update
            return true;
    }
}
